import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControlledColorFilter } from '@vlabs/monokit/shared/ui/controlled-color-filter';
import { ControlledOptionsFilter } from '@vlabs/monokit/shared/ui/controlled-options-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { useTranslation } from 'react-i18next';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

function HeadwearFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useWorkspaceFilters();
  const colors = filters.headwear_apparent_colors ?? [];
  const states = filters.headwear_states ?? [];
  const colorOptions = EVENT_ENUMS.UPPER_BODY.HEADWEAR_COLORS.raw as Option[];
  const stateOptions = EVENT_ENUMS.UPPER_BODY.HEADWEAR.raw as Option[];

  const reset = () => updateFilters({
    headwear_apparent_colors: undefined,
    headwear_states: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={colors.length === 0 && states.length === 0}
      onClickReset={reset}
      ref={ref}
    >
      <ControlledColorFilter
        label={t('events:headwear_colors')}
        onChange={(value) => updateFilters({
          headwear_apparent_colors: value.length > 0 ? value : undefined,
        })}
        options={colorOptions}
        value={colors}
      />
      <div className={st.SectionDivider} />
      <ControlledOptionsFilter
        label={t('events:headwear')}
        name="headwear_states"
        onChange={(value) => updateFilters({
          headwear_states: value.length > 0 ? value : undefined,
        })}
        options={stateOptions}
        value={states}
      />
    </PopoverWithButton>
  );
}

const HeadwearFilterPopoverWithRef = forwardRef(HeadwearFilterPopover);
export { HeadwearFilterPopoverWithRef as HeadwearFilterPopover };
